export default {
  admin: () => import("E:/TyApp/layouts/admin.vue")
}